module.exports = __webpack_public_path__ + "media/05uncover.ecbf15f1.mp3";